import { createContext } from "react";
import { IContext } from "./home.types";

export const Context = createContext<IContext | undefined>(undefined);
